// src/hooks/useScrollReveal.js
import { useEffect } from 'react';

/**
 * Custom hook to handle scroll reveal animations
 * @param {string} selector - CSS selector for elements to animate (default: '.reveal')
 * @param {number} threshold - How much of the element needs to be visible (default: 150px)
 */
const useScrollReveal = (selector = '.reveal', threshold = 150) => {
    useEffect(() => {
        // Select all elements that need to be revealed
        const revealElements = document.querySelectorAll(selector);

        // Function to check and reveal elements when scrolled into view
        const revealOnScroll = () => {
            for (let i = 0; i < revealElements.length; i++) {
                const windowHeight = window.innerHeight;
                const elementTop = revealElements[i].getBoundingClientRect().top;

                if (elementTop < windowHeight - threshold) {
                    revealElements[i].classList.add('active');
                } else {
                    // Optional: To re-hide elements when scrolled out of view
                    // revealElements[i].classList.remove('active');
                }
            }
        };

        // Add scroll event listener
        window.addEventListener('scroll', revealOnScroll);

        // Check on initial load
        revealOnScroll();

        // Clean up event listener
        return () => {
            window.removeEventListener('scroll', revealOnScroll);
        };
    }, [selector, threshold]);
};

export default useScrollReveal;